import { datadogLogs } from '@datadog/browser-logs'

/**
 * Stable error IDs for the Bulk Invite (CSV) flow. Each names a single
 * production failure point so logs can be grepped/alerted on without parsing
 * free-text messages.
 */
export type BulkInviteErrorId =
  | 'bulk_invite.upload_failed'
  | 'bulk_invite.mapping_save_failed'
  | 'bulk_invite.send_failed'
  | 'bulk_invite.status_poll_failed'
  | 'bulk_invite.missing_organization'
  | 'bulk_invite.missing_bulk_invite_id'
  | 'bulk_invite.missing_preview'
  | 'bulk_invite.invitee_missing_email'

export interface BulkInviteErrorContext {
  organizationId?: string | null
  bulkInviteId?: string | null
  [key: string]: unknown
}

/**
 * Log a Bulk Invite failure to Datadog (forwarded to error tracking) with a
 * stable error ID plus the org/invite identifiers so on-call can locate the
 * resource. The datadog SDK is a no-op until `datadogLogs.init` runs, so this is
 * safe to call in tests and SSR.
 */
export function logBulkInviteError(
  errorId: BulkInviteErrorId,
  context: BulkInviteErrorContext = {},
  error?: unknown,
): void {
  datadogLogs.logger.error(
    errorId,
    { errorId, ...context },
    error instanceof Error ? error : undefined,
  )
}
